export function getAssetBusinessTypeTranslationKey(businessType, casing = 'sentence') {
  return `marketplace-ui-assets-core.assets.businessType.${businessType}.${casing}`;
}
export function getAssetPageTypeTranslationKey(pageType, casing = 'sentence') {
  return `marketplace-ui-assets-core.assets.pageType.${pageType}.${casing}`;
}
export function getAssetPageFeatureTranslationKey(feature, casing = 'sentence') {
  return `marketplace-ui-assets-core.assets.pageFeature.${feature}.${casing}`;
}

/**
 * @deprecated Use getAssetBusinessTypeTranslationKey instead.
 * Example: getAssetBusinessTypeTranslationKey(businessType, 'sentence' | 'title' | 'lower')
 */
export function getAssetBusinessTypeI18nKey(businessType, sentenceCase = true) {
  return getAssetBusinessTypeTranslationKey(businessType, sentenceCase ? 'sentence' : 'title');
}

/**
 * @deprecated Use getAssetPageTypeTranslationKey instead.
 * Example: getAssetPageTypeTranslationKey(pageType, 'sentence' | 'title' | 'lower')
 */
export function getAssetPageTypeI18nKey(pageType, sentenceCase = true) {
  return getAssetPageTypeTranslationKey(pageType, sentenceCase ? 'sentence' : 'title');
}

/**
 * @deprecated Use getAssetPageFeatureTranslationKey instead.
 * Example: getAssetPageFeatureTranslationKey(feature, 'sentence' | 'title' | 'lower')
 */
export function getAssetPageFeatureI18nKey(feature, sentenceCase = true) {
  return getAssetPageFeatureTranslationKey(feature, sentenceCase ? 'sentence' : 'title');
}